export enum MotorStatus {
  OK = 'ok',
  ERROR = 'error',
  BUY_ONLY = 'buyonly',
  WARNING = 'warning',
  SAVE_NEW = 'savenew',
  SAVE_ONLY = 'saveonly',
  QUOTE = 'quote',
}
export enum MotorReferral {
  AGENCY = 'agency',
  AGENCY_WEBSITE = 'agencywebsite',
  ALLIANZ_NOW = 'AllianzNOW',
  AGENCY_WEBSITE_DESKTOP = 'agencyAllianzitDesktop',
  AGENCY_WEBSITE_MOBILE = 'agencyAllianzitMobile',
  ECOMMERCE = 'ecommerce',
  FASTQUOTE = 'fastquote',
}

export enum MotorOperationType {
  INSTALLMENT = '4',
  RENEWAL = '3',
}

export enum MotorStatusMessages {
  ALLIANZ_PAY_NOT_FOUND = 'Preventivo non trovato',
  ALLIANZ_PAY_INVALID_CODE = 'Preventivo scaduto',
  ALLIANZ_PAY_OVER_DATE = 'Data decorrenza superata',
}
